var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArivatic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.324219 10.5498C0.324219 5.02696 4.80137 0.549805 10.3242 0.549805H38.3242C43.8471 0.549805 48.3242 5.02696 48.3242 10.5498V38.5498C48.3242 44.0727 43.8471 48.5498 38.3242 48.5498H10.3242C4.80137 48.5498 0.324219 44.0727 0.324219 38.5498V10.5498Z",
    fill: "url(#paint0_linear_4168_5984)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2597 28.0491C22.1704 27.703 21.99 27.3872 21.7373 27.1345C21.4846 26.8817 21.1688 26.7014 20.8227 26.6121L14.6877 25.0301C14.583 25.0004 14.4909 24.9373 14.4253 24.8505C14.3597 24.7637 14.3242 24.6579 14.3242 24.5491C14.3242 24.4403 14.3597 24.3344 14.4253 24.2476C14.4909 24.1608 14.583 24.0978 14.6877 24.0681L20.8227 22.4851C21.1686 22.3959 21.4844 22.2157 21.7371 21.9631C21.9898 21.7106 22.1703 21.395 22.2597 21.0491L23.8417 14.9141C23.8711 14.809 23.9341 14.7164 24.021 14.6505C24.108 14.5845 24.2141 14.5488 24.3232 14.5488C24.4323 14.5488 24.5384 14.5845 24.6254 14.6505C24.7123 14.7164 24.7753 14.809 24.8047 14.9141L26.3857 21.0491C26.475 21.3951 26.6554 21.711 26.9081 21.9637C27.1608 22.2164 27.4766 22.3968 27.8227 22.4861L33.9577 24.0671C34.0632 24.0962 34.1562 24.1591 34.2225 24.2462C34.2888 24.3332 34.3247 24.4396 34.3247 24.5491C34.3247 24.6585 34.2888 24.7649 34.2225 24.852C34.1562 24.9391 34.0632 25.002 33.9577 25.0311L27.8227 26.6121C27.4766 26.7014 27.1608 26.8817 26.9081 27.1345C26.6554 27.3872 26.475 27.703 26.3857 28.0491L24.8037 34.1841C24.7743 34.2892 24.7113 34.3817 24.6244 34.4477C24.5374 34.5136 24.4313 34.5493 24.3222 34.5493C24.2131 34.5493 24.107 34.5136 24.02 34.4477C23.9331 34.3817 23.8701 34.2892 23.8407 34.1841L22.2597 28.0491Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3242 15.5508V19.5508",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3242 17.5508H30.3242",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3242 29.5508V31.5508",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3242 30.5508H15.3242",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4168_5984",
    x1: 24.3242,
    y1: 0.549805,
    x2: 24.3242,
    y2: 48.5498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#155DFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60A5FA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArivatic);
export default __webpack_public_path__ + "static/media/Arivatic.6505c90e34039c2d241f650780eb4785.svg";
export { ForwardRef as ReactComponent };